import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { UserDelegationTargetKindEnum } from '@zaoblako/shared/modules/security/enums/user-delegation-target-kind.enum';
import { UserDelegationTargetKindEnumI18n } from '@zaoblako/shared/modules/security/i18n/user-delegation-target-kind-enum.i18n';

@Pipe({
  name: 'userDelegationTargetKindName',
  standalone: true
})
export class UserDelegationTargetKindNamePipe implements PipeTransform {
  public transform(kind: UserDelegationTargetKindEnum): string {
    return UserDelegationTargetKindEnumI18n[I18nLocalesEnum.RU_RU][kind] || '';
  }
}
